import * as moment from 'moment';

export default function getMonthsBetween(
  startDate: string,
  endDate: string,
): number {
  return moment(endDate)
    .utcOffset(0)
    .add(1, 'day')
    .diff(startDate, 'months');
}
